import { html, TemplateResult } from 'lit';
import { advanceStep } from '../../../types/steps';
import { BookingRequest, Dispatcher } from '../../../types/booking-request';
import { Failure } from '@mrhenry/failure';
import { getOption } from '../../../api/get-option';
import { checkIfPersonalDetailsValid } from '../../../types/personal-details';
import { checkIfBookingDataIsValid } from '../../../types/booking-data';
import { staticText } from '../../../static-text';
import { enhancedEcommerceCheckout } from '../../../helpers/enhanced-ecommerce';
import { cleaningServicePriceInCents } from '../../../constants';
import { subTotalInCents } from '../../../helpers/subtotal';

export function makeBookingRequestButton(
	state: BookingRequest,
	dispatch: Dispatcher
): TemplateResult {
	const incrementCurrentStepHandler = async() => {
		// TODO: Show loading status for long calls.

		const optionStatus = await getOption( state );

		if ( Failure.isFailure( optionStatus ) ) {
			dispatch( {
				type: 'UPDATE_BOOKING_FAILURE',
				bookingFailure: optionStatus,
			} );

			return;
		}

		switch ( optionStatus ) {
			case 'INPUT_ERROR':
				dispatch( {
					type: 'UPDATE_BOOKING_FAILURE',
					bookingFailure: Failure.from( staticText.bookingFailedLikelyInputValuesAreWrong ),
				} );

				return;
			case 'CONFLICTING_RESERVATION':
				dispatch( {
					type: 'UPDATE_BOOKING_FAILURE',
					bookingFailure: Failure.from( staticText.bookingFailedBecauseOfReservationConflict ),
				} );

				return;
			case 'OPTION_ALREADY_HANDLED':
				dispatch( {
					type: 'UPDATE_BOOKING_FAILURE',
					bookingFailure: Failure.from( staticText.bookingFailedBecauseItsADuplicate ),
				} );

				return;
			case 'OK':
				if ( state.bookingData.houseId && state.bookingData.houseTitle ) {
					enhancedEcommerceCheckout( state.bookingData.houseId, state.bookingData.houseTitle, subTotalInCents( state.bookingData.weekData, cleaningServicePriceInCents ) );
				}
				break;
			default:
				throw new Error( `invariant: option status after booking has unknown value : ${JSON.stringify( optionStatus )}` );
		}

		dispatch( {
			type: 'UPDATE_CURRENT_STEP',
			currentStep: advanceStep( state.currentStep ),
		} );
	};

	return html`
		<button
			.disabled=${!checkIfBookingDataIsValid( state.bookingData.weekData ) || !checkIfPersonalDetailsValid( state.personalDetails )}
			@click=${incrementCurrentStepHandler}
			class="button"
		>
			${staticText.makeBookingRequest}
		</button>
	`;
}
